import { Component } from '@angular/core';
import { Validators } from '@angular/forms';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from 'src/app/modules/login/login.service';
import { RatesService } from 'src/app/modules/rates/_services/rates.service';
import { WorkerRatesService } from 'src/app/modules/rates/_services/workers-rates.service';
import { WorkerRate } from 'src/app/modules/rates/_types/worker-rate';

@Component({
    selector: 'app-worker-rate',
    templateUrl: './worker-rate.component.html',
    styleUrls: ['./worker-rate.component.scss'],
    standalone: false
})
export class WorkerRateComponent {
  public workerRateFormGroup!: RxFormGroup;

  public workerRate: WorkerRate = new WorkerRate();
  public rates: any[] = [];

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;


  constructor(
    private workerRatesService: WorkerRatesService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private ratesService: RatesService,
    private loginService: LoginService
  ) {
    this.workerRateFormGroup = this.formBuilder.formGroup<WorkerRate>(this.workerRate) as RxFormGroup;
    this.workerRateFormGroup.controls['rateId'].setValidators([Validators.required]);
  }

  ngOnInit(): void {
    if (this.config.data.workerRateId) {
      this.loadWorkerRate(this.config.data.workerRateId);
    } else {
      this.workerRate.workerId = this.config.data.workerId;
    }
    this.loadRates();

    this.allowWrite = this.loginService.hasPermission("WORKERS.WRITE");
    this.allowDelete = this.loginService.hasPermission("WORKERS.DELETE");
  }

  async loadWorkerRate(id: string) {
    this.workerRate = await firstValueFrom(this.workerRatesService.get(id));
    this.workerRateFormGroup.patchValue(this.workerRate);
  }

  async loadRates() {
    let filter:any = {
      typeOfRate: new Filter(FilterOperation.equals, 'typeOfRate', '', 'Worker'),
    };
    let params:IParamsCollection = {
      sort: ['name'],
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.ratesService.all(params));
    let existentRates = this.config.data.existentRates;

    this.rates = response.data;
    this.rates = this.rates.filter((rate: any) => {
      return !existentRates.some((existentRate: any) => existentRate.rate.id === rate.id) || (this.config.data!=null && this.config.data.rateId === rate.id);
    });
  }


  async save() {
    let valid = this.formValidationService.validateForm(this.workerRateFormGroup);
    if (valid) {
      this.workerRate = Object.assign(this.workerRate, this.workerRateFormGroup.value);

      await this.workerRatesService.save(this.workerRate).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Baremo asignado correctamente' });
          this.dynamicDialogRef.close();
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al asignar el baremo' });
        }
      });
    } else {
      document.getElementById('form')?.classList.add('formInvalid');
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea desasignar el baremo?",
      header: "Desasignar baremo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerRatesService.delete(this.workerRate.id).subscribe({
          next: () => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Baremo desasignado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

}
